(() => {
  const SELECTOR = '[data-nd-cross-sell]';

  const money = (value) => {
    const number = Number(value || 0);

    try {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        maximumFractionDigits: 0,
      }).format(number);
    } catch (error) {
      return `$${Math.round(number).toLocaleString('es-CL')}`;
    }
  };

  const escapeHtml = (value = '') =>
    String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  const normalizeCode = (value) =>
    String(value || '').trim().toUpperCase();

  const getRelatedCodes = () => {
    const source = document.querySelector(
      '[data-nd-fs-related-codes-source]'
    );

    if (!source) return [];

    const codes = [
      ...source.querySelectorAll('tbody tr td:nth-child(2)')
    ]
      .flatMap((cell) =>
        cell.textContent
          .split(/[,;/\n]+/)
          .map(normalizeCode)
      )
      .filter(Boolean);

    return [...new Set(codes)];
  };

  const getCurrentProductCode = () => {
    const block = document.querySelector(
      '[data-nd-current-product-code]'
    );

    return normalizeCode(
      block?.dataset?.ndCurrentProductCode
    );
  };

  const createCard = (product, label) => {
    const article = document.createElement('article');

    article.className =
      'nd-cross-sell-card nd-cross-sell-card--technical';

    article.dataset.ndTechnicalRelated =
      product.productId || product.url || label;

    const currentPrice = money(product.price);
    const comparePrice =
      Number(product.compareAtPrice || 0) > Number(product.price || 0)
        ? `<span class="nd-cross-sell-card__price-compare">${money(product.compareAtPrice)}</span>`
        : '';

    article.innerHTML = `
      <div class="nd-cross-sell-card__technical-label">
        ${escapeHtml(label)}
      </div>

      <a
        class="nd-cross-sell-card__media"
        href="${escapeHtml(product.url || '#')}"
      >
        ${
          product.image
            ? `
              <img
                class="nd-cross-sell-card__image"
                src="${escapeHtml(product.image)}"
                alt="${escapeHtml(product.imageAlt || product.title || '')}"
                loading="lazy"
              >
            `
            : `
              <div class="nd-cross-sell-card__placeholder">
                Sin imagen
              </div>
            `
        }
      </a>

      <div class="nd-cross-sell-card__body">
        ${
          product.vendor
            ? `
              <div class="nd-cross-sell-card__vendor">
                ${escapeHtml(product.vendor)}
              </div>
            `
            : ''
        }

        <a
          href="${escapeHtml(product.url || '#')}"
          class="nd-cross-sell-card__title"
        >
          ${escapeHtml(product.title || '')}
        </a>

        <div class="nd-cross-sell-card__price">
          <span class="nd-cross-sell-card__price-current">
            ${currentPrice}
          </span>
          ${comparePrice}
        </div>

        <form class="nd-related-atc-form">
          <input
            type="hidden"
            name="id"
            value="${escapeHtml(product.variantId)}"
          >
          <input
            type="hidden"
            name="quantity"
            value="1"
          >

          <button
            type="submit"
            class="nd-cross-sell-card__button"
            ${product.available ? '' : 'disabled'}
          >
            <span data-nd-related-atc-text>
              ${product.available ? 'Agregar' : 'Agotado'}
            </span>
          </button>
        </form>
      </div>
    `;

    const form = article.querySelector('.nd-related-atc-form');

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();

      const button = form.querySelector('button');
      const text = form.querySelector('[data-nd-related-atc-text]');

      if (!button || button.disabled) return;

      const original = text?.textContent || 'Agregar';

      button.disabled = true;
      if (text) text.textContent = 'Agregando…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: new FormData(form),
        });

        const item = await response.json();

        if (!response.ok) {
          throw new Error(
            item.description ||
            item.message ||
            'No fue posible agregar el producto.'
          );
        }

        if (text) text.textContent = 'Agregado ✓';

        let cart = null;

        try {
          const cartResponse = await fetch('/cart.js', {
            headers: {
              Accept: 'application/json',
            },
          });

          if (cartResponse.ok) {
            cart = await cartResponse.json();
          }
        } catch (error) {}

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                itemCount: cart?.item_count ?? 1,
                source: 'nodara-related-cross-sell',
                cart,
                addedItem: item,
              },
            },
          })
        );

        setTimeout(() => {
          button.disabled = false;
          if (text) text.textContent = original;
        }, 1200);
      } catch (error) {
        console.error(
          '[Nodara PDP] Error agregando producto relacionado.',
          error
        );

        if (text) text.textContent = 'Error';

        setTimeout(() => {
          button.disabled = false;
          if (text) text.textContent = original;
        }, 1400);
      }
    });

    return article;
  };

  const uniqueProducts = (items) => {
    const seen = new Set();

    return items.filter((item) => {
      const key = item.productId || item.url;
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  const init = async (block) => {
    if (!block || block.dataset.ndTechnicalReady === 'true') return;

    const mapUrl = block.dataset.ndRelatedMapUrl;
    if (!mapUrl) return;

    const relatedCodes = getRelatedCodes();
    const currentCode = getCurrentProductCode();

    if (!relatedCodes.length && !currentCode) return;

    let payload;

    try {
      const response = await fetch(mapUrl, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return;

      payload = await response.json();
    } catch (error) {
      console.warn(
        '[Nodara PDP] No fue posible cargar índice técnico.',
        error
      );
      return;
    }

    const productsByCode = payload?.productsByCode || {};
    const relatedToCode = payload?.relatedToCode || {};

    const exactMatches = relatedCodes
      .map((code) => ({
        code,
        product: productsByCode[code],
      }))
      .filter((item) => item.product);

    const inverseMatches = currentCode
      ? (relatedToCode[currentCode] || [])
      : [];

    const track = block.querySelector(
      '[data-nd-cross-sell-track]'
    );

    if (!track) return;

    const insertTechnicalCards = () => {
      if (
        track.querySelector('[data-nd-technical-related]')
      ) {
        return true;
      }

      const fragment = document.createDocumentFragment();

      const exactProducts = uniqueProducts(
        exactMatches.map((item) => item.product)
      );

      exactMatches.forEach(({ code, product }) => {
        if (!product) return;
        fragment.appendChild(
          createCard(product, `Compatible · ${code}`)
        );
      });

      const exactIds = new Set(
        exactProducts.map((item) => item.productId)
      );

      uniqueProducts(inverseMatches)
        .filter((product) => !exactIds.has(product.productId))
        .slice(0, 3)
        .forEach((product) => {
          fragment.appendChild(
            createCard(
              product,
              currentCode
                ? `Relacionado con ${currentCode}`
                : 'Relacionado'
            )
          );
        });

      if (!fragment.childNodes.length) {
        block.dataset.ndTechnicalReady = 'true';
        return true;
      }

      track.prepend(fragment);
      block.dataset.ndTechnicalReady = 'true';

      return true;
    };

    if (!track.querySelector('.nd-cross-sell__loading')) {
      insertTechnicalCards();
      return;
    }

    const observer = new MutationObserver(() => {
      if (!track.querySelector('.nd-cross-sell__loading')) {
        insertTechnicalCards();
        observer.disconnect();
      }
    });

    observer.observe(track, {
      childList: true,
      subtree: false,
    });

    setTimeout(() => {
      insertTechnicalCards();
      observer.disconnect();
    }, 2500);
  };

  const initAll = () => {
    document.querySelectorAll(SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
